<template>
  <div>
    <div :key="reRender">
      <div v-if="isCommentsEmpty">
        <DesertMessage
          class="bg-neutro-200 rounded"
          :mainTitle="$t('message.documentDetail.comments.empty.title')"
          :mainContent="$t('message.documentDetail.comments.empty.content')"
        />
      </div>
      <div
        v-else
        :class="[comments.length >= 3 ? 'max-h-custom overflow-y-auto custom-scroll pr-1' : '']"
      >
        <div v-for="comment in comments" :key="comment.idobservacion_doc">
          <CommentItem
            :comment="comment"
            @delete-comment="deleteComment"
            class="mb-4"
          />
        </div>
      </div>
    </div>
    <div v-if="isActionAllowed(25)" class="pt-4 flex justify-end">
      <zt-button
        icon="plus-outline"
        outlined
        @click="activeAddDialog(true)"
      >
        {{ $t('message.documentDetail.comments.buttonAddComment') }}
      </zt-button>
    </div>
    <ObservationAddDialogDialog :active="shownAddDialog" />
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import { mapGetters } from 'vuex'
import ObservationAddDialogDialog from '@/modules/Documents/detail/components/modals/ObservationAddDialog.vue'
import DesertMessage from '@/components/generics/DesertMessage404.vue'
import ConfirmCancelDialog from '@/modules/Documents/detail/components/modals/ConfirmCancelDialog.vue'
import CommentItem from '@/modules/Documents/detail/components/ConfigDocument/CommentItem.vue'
import Folders from '@/apiClient/Folders'
import Search from '@/apiClient/Search'

export default {
  name: 'Comment',
  inject: ['stateDetailStore', 'setDocumentDetail'],
  provide() {
    return {
      activeAddDialog: this.activeAddDialog,
      addObservation: this.addObservation,
      deleteComment: this.deleteComment
    }
  },
  components: {
    ConfirmCancelDialog,
    DesertMessage,
    CommentItem,
    ObservationAddDialogDialog
  },
  data() {
    return {
      comments: [],
      shownAddDialog: false,
      reRender: 0
    }
  },
  computed: {
    ...mapGetters(['isActionAllowed']),
    isCommentsEmpty() {
      return isEmpty(this.comments)
    }
  },
  created() {
    this.foldersApi = new Folders()
    this.searchApi = new Search()
    this.comments = this.stateDetailStore.detail.observation
    this.reRender += 1
  },
  methods: {
    activeAddDialog(show) {
      this.shownAddDialog = show
    },
    async addObservation({ comment }) {
      try {
        this.isLoading = true
        await this.foldersApi.addObservation({
          iddoc: this.stateDetailStore.detail.idDocument,
          comment
        })
        await this.updateDocumentDetail()
        this.reRender += 1
        this.isLoading = false
      } catch (e) {
        console.error(e)
      }
    },
    async deleteComment(id) {
      try {
        this.isLoading = true
        await this.foldersApi.deleteObservation({
          idobservacion_doc: id
        })
        await this.updateDocumentDetail()
        this.reRender += 1
        this.isLoading = false
      } catch (e) {
        console.error(e)
      }
    },
    async updateDocumentDetail() {
      try {
        const {
          data: { data }
        } = await this.searchApi.getDocumentDetail(this.stateDetailStore.detail.idDocument)
        this.setDocumentDetail({
          idDocument: this.stateDetailStore.detail.idDocument,
          ...data
        })
        this.comments = this.stateDetailStore.detail.observation
        this.isLoading = false
      } catch (error) {
        this.isEmpty = true
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.custom-scroll::-webkit-scrollbar-track {
  background-color: #c4c4c4;
}
.custom-scroll::-webkit-scrollbar {
  width: 0.625rem;
}
.custom-scroll::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #888888;
}
.max-h-custom {
  max-height: 45rem;
}
.bg-neutro-200 {
  background-color: #EBEBEB;
}
</style>
